module.exports = __webpack_public_path__ + "static/fv-media-23740ac830ed53a22d7d3ed89cb1ff44.jpg";